module.exports = __webpack_public_path__ + "img/3.2862e48e.png";